import useRollbarUtil from "@/components/hooks/useRollbarUtil";
import { useNowQuery } from "@/generated/graphql_billing";
import { APIContext } from "@/libs/constants";
import { firstDayOfMonth } from "@/libs/time";
import { lastDayOfMonth } from "date-fns";
import { useMemo } from "react";

export const useNow = () => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();

  const { loading, data, refetch } = useNowQuery({
    onError: getNotifyErrorHandlerForGraphQL("error getting now"),
    context: {
      api: APIContext.BILLING,
    },
  });

  const now = useMemo(() => new Date(data?.now), [data]);

  const { nowYearMonth, firstDayOfNowMonth, lastDayOfNowMonth } =
    useMemo(() => {
      if (!now) return {};

      const firstDayOfNowMonth = firstDayOfMonth(now);
      const lastDayOfNowMonth = lastDayOfMonth(now);

      return {
        nowYearMonth: firstDayOfNowMonth,
        firstDayOfNowMonth,
        lastDayOfNowMonth,
      };
    }, [now]);

  return {
    now,
    nowLoading: loading,
    nowRefetch: refetch,
    nowYearMonth,
    firstDayOfNowMonth,
    lastDayOfNowMonth,
  };
};
